import * as React from 'react';
import { Flex } from '@adobe/react-spectrum';
import styles from './MobileSearchResultItem.module.css';

export interface IMobileSearchResultItemProps {
    html_id:string;
    image: string;
    title: string;
    subtitle: string;
    link: string;
    breadcrumbs: string[];
    onSearchSelected: (item:any) => void;
    contextType: string;
    contextId?: number;
    stateName?: string;
    stateColor?: string;
}

export function MobileSearchResultItem ({
    html_id,
    image,
    title,
    subtitle,
    link,
    breadcrumbs,
    onSearchSelected,
    contextType,
    contextId,
    stateName,
    stateColor,
}: IMobileSearchResultItemProps) {
    const handleClicked = () => { 
        onSearchSelected({link , contextType, contextId});
    }
  return (
    <>
        <span onClick={handleClicked} id={html_id}>
            <Flex direction="row" gap="size-100" alignItems="start" UNSAFE_className={styles.itemContainer}>
                <img src={image} alt="search result" className={styles.searchResultImage} />
                <Flex direction="column" gap="size-50" flex>
                    <div className={styles.searchResultTitle}>{title}</div>
                    <div className={styles.searchResultSubtitle}>{subtitle}</div>
                    <div className={styles.searchResultBreadcrumbs}>{breadcrumbs.join(' > ')}</div>
                </Flex>
                {stateName && (
                    <div className={styles.rightContainer}>
                        <div className={styles.searchResultIndicator} style={{backgroundColor: stateColor}}></div>
                        <div className={styles.searchResultStatus}>{stateName}</div>
                    </div>
                )}
            </Flex>
        </span>
    </>
  );
}
